<template>
    <common-modal-slide :showHeader="false" :showFooter="false" @close="closeChatBox">
        <div id="kt_drawer_chat" class="bg-body drawer drawer-end drawer-on" data-kt-drawer="true" data-kt-drawer-name="chat" data-kt-drawer-activate="true" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'300px', 'md': '500px'}" style="width:550px;" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_drawer_chat_toggle" data-kt-drawer-close="#kt_drawer_chat_close">
            <!--begin::Messenger-->
            <div class="card w-100 border-0 rounded-0" id="kt_drawer_chat_messenger">
                <!--begin::Card header-->
                <div class="card-header pe-5" id="kt_drawer_chat_messenger_header">

                    <!--begin::Title-->
                    <div class="card-title" v-if="detailChatGroup.type == 1">
                        <a href="javascript:;" @click="backListChat()" class="d-flex btn btn-icon btn-light btn-active-secondary btn-sm me-1 mb-2 lh-1">
                            <i class="ki-duotone ki-black-left fs-2">
                            </i>
                        </a>
                        <!--begin::User-->
                        <div class="d-flex justify-content-center flex-column me-3">

                            <a href="javascript:;" class="fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1">{{detailChatGroup.name}}</a>
                            <!--begin::Info-->
                            <div class="mb-0 lh-1" v-if="detailChatGroup.isOnline">
                                <span class="badge badge-success badge-circle w-10px h-10px me-1"></span>
                                <span class="fs-7 fw-semibold text-muted">Active</span>
                            </div>
                            <div class="mb-0 lh-1" v-else>
                                <span class="badge badge-light-danger badge-circle w-10px h-10px me-1"></span>
                                <span class="fs-7 fw-semibold text-muted">Offline</span>
                            </div>
                            <!--end::Info-->
                        </div>
                        <!--end::User-->
                    </div>
                    <!--begin::Title-->
                    <div class="card-title" v-else>
                        <a href="javascript:;" @click="backListChat()" class="d-flex btn btn-icon btn-light btn-active-secondary btn-sm me-1 mb-2 lh-1">
                            <i class="ki-duotone ki-black-left fs-2">
                            </i>
                        </a>
                        <a href="javascript:;" class="fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1">{{detailChatGroup.name}}</a>
                        <!--begin::Users-->
                        <div class="symbol-group symbol-hover">

                            <!--begin::Avatar-->
                            <div class="symbol symbol-35px symbol-circle" v-for="(item,index) in detailChatGroup.listUserOfGroup" :key="index">
                                <common-avatar :src="item.avatar" :name="item.fullName" />
                            </div>

                            <!-- <a href="#" class="symbol symbol-35px symbol-circle" data-bs-toggle="modal" data-bs-target="#kt_modal_view_users">
                                   <span class="symbol-label fs-8 fw-bold" data-bs-toggle="tooltip" data-bs-trigger="hover" title="View more users">+42</span>
                               </a>
                            -->
                        </div>
                        <!--end::Users-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Card toolbar-->
                    <div class="card-toolbar">
                        <!--begin::Menu-->
                        <div class="btn btn-sm btn-icon btn-active-color-primary" id="kt_drawer_chat_close">
                            <i class="ki-duotone ki-whatsapp fs-2x">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <div class="me-0">
                            <button class="btn btn-sm btn-icon btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                <i class="ki-duotone ki-dots-square fs-2">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                    <span class="path3"></span>
                                    <span class="path4"></span>
                                </i>
                            </button>
                            <!--begin::Menu 3-->
                            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-kt-menu="true" id="box-add-user">
                                <!--begin::Heading-->
                                <div class="menu-item px-3">
                                    <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Thao tác</div>
                                </div>
                                <!--end::Heading-->
                                <!--begin::Menu item-->
                                <div class="menu-item px-3" v-if="detailChatGroup.type == 2">
                                    <a href="javascript:;" v-if="detailChatGroup.documentId > 0" class="menu-link px-3" data-bs-toggle="modal" data-bs-target="#kt_modal_users_search" @click="gotoDocument()">Ca hồ sơ</a>
                                    <a href="javascript:;" class="menu-link px-3" data-bs-toggle="modal" data-bs-target="#kt_modal_users_search" @click="openUserToChatGroup()">Thêm thành viên</a>
                                </div>


                                <!--end::Menu item-->
                            </div>
                            <!--end::Menu 3-->
                        </div>
                        <!--end::Menu-->
                        <!--begin::Close-->
                        <div class="btn btn-sm btn-icon btn-active-color-primary" id="kt_drawer_chat_close" @click="closeChatBox()">
                            <i class="ki-duotone ki-cross-square fs-2">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Card toolbar-->
                </div>
                <!--end::Card header-->
                <!--begin::Card body-->
                <div class="card-body" id="kt_chat_messenger_body">
                    <!--begin::Messages-->
                    <div class=" me-n5 pe-5 h-300px h-lg-auto">
                        <!--begin::Message(in)-->
                        <template v-for="item in listChatMessage">
                            <div v-if="item.senderId !== currentUser.id" class="d-flex justify-content-start mb-10" :key="`friend-${item.id}`">
                                <!--begin::Wrapper-->
                                <div class="d-flex flex-column align-items-start">
                                    <!--begin::User-->
                                    <div class="d-flex align-items-center mb-2">
                                        <!--begin::Avatar-->
                                        <div class="symbol symbol-35px symbol-circle">
                                            <common-avatar :src="item.senderAvatar" :name="item.senderName" v-if="item.senderAvatar" />
                                            <img v-else src="~assets/media/auth/no-avatar.jpg" />
                                        </div>
                                        <!--end::Avatar-->
                                        <!--begin::Details-->
                                        <div class="ms-3">
                                            <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{item.senderName}}</a>
                                            <span class="text-muted fs-7 mb-1">{{formatDateTime(item.createdDate)}}</span>
                                        </div>
                                        <!--end::Details-->
                                    </div>
                                    <!--end::User-->
                                    <!--begin::Text-->

                                    <div v-if="item.type == 1" class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text" v-html="item.content"></div>
                                    <div v-else-if="item.type == 3" class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text">

                                        <div v-if=" item.listFilePath && item.listFilePath.length > 0" :class="{'list-img-in-msg':true, 'three-img': item.listFilePath.length > 2, 'two-img':item.listFilePath.length  == 2, 'one-img':item.listFilePath.length  == 1}">
                                            <template v-if="item.listFilePath && item.listFilePath.length > 0">

                                                <div @click="openViewer(0,item.listFilePath)" class="item-img">
                                                    <common-image :filePath="item.listFilePath[0]" alt="" />
                                                </div>
                                                <div @click="openViewer(1,item.listFilePath)" class="item-img" v-if="item.listFilePath.length > 1">
                                                    <common-image :filePath="item.listFilePath[1]" alt="" />
                                                </div>
                                                <div @click="openViewer(2,item.listFilePath)" class="item-img item-more-img" v-if="item.listFilePath.length > 2">
                                                    <common-image :filePath="item.listFilePath[2]" alt="" />
                                                    <span v-if="item.listFilePath.length > 3" class="bg"></span>
                                                    <span v-if="item.listFilePath.length > 3" class="nb-more">+{{ item.listFilePath?.length - 3 }}</span>
                                                </div>
                                                <div style="display: none;" class="item-img" v-if="item.listFilePath.length > 3">
                                                    <common-image :filePath="im" alt="" v-for="(im,imD) in item.listFilePath.slice(3)" :key="imD" />
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                    <div v-else-if="item.type == 2" class="p-3 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start mb-3">
                                        <div @click="openFilePath(fi)" class="upload-file-mess" v-for="(fi,i) in item.listFilePath" :key="i">
                                            <span class="icon">
                                                <img src="/assets/img-fix/icon/document-solid-dark.svg" alt="">
                                            </span>
                                            <span class="text">{{thenFileName(fi)}}</span>
                                        </div>
                                    </div>
                                    <!--end::Text-->
                                </div>
                                <!--end::Wrapper-->
                            </div>
                            <div class="d-flex justify-content-end mb-10" v-else>
                                <!--begin::Wrapper-->
                                <div class="d-flex flex-column align-items-end">
                                    <!--begin::User-->
                                    <div class="d-flex align-items-center mb-2">
                                        <!--begin::Details-->
                                        <div class="me-3">
                                            <span class="text-muted fs-7 mb-1">{{formatDateTime(item.createdDate)}}</span>
                                            <a href="javascript:;" class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">Bạn</a>
                                        </div>
                                        <!--end::Details-->
                                        <!--begin::Avatar-->
                                        <div class="symbol symbol-35px symbol-circle">
                                            <common-avatar :src="item.senderAvatar" :name="item.senderName" v-if="item.senderAvatar" />
                                            <img v-else src="~assets/media/auth/no-avatar.jpg" />
                                        </div>
                                        <!--end::Avatar-->
                                    </div>
                                    <!--end::User-->
                                    <!--begin::Text-->
                                    <div v-if="item.type == 1" class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end" data-kt-element="message-text" v-html="item.content"></div>
                                    <div v-else-if="item.type == 3" class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end" data-kt-element="message-text">

                                        <div v-if=" item.listFilePath && item.listFilePath.length > 0" :class="{'list-img-in-msg':true, 'three-img': item.listFilePath.length > 2, 'two-img':item.listFilePath.length  == 2, 'one-img':item.listFilePath.length  == 1}">
                                            <template v-if=" item.listFilePath && item.listFilePath.length > 0">

                                                <div @click="openViewer(0,item.listFilePath)" class="item-img">
                                                    <common-image :filePath="item.listFilePath[0]" alt="" />
                                                </div>
                                                <div @click="openViewer(1,item.listFilePath)" class="item-img" v-if="item.listFilePath.length > 1">
                                                    <common-image :filePath="item.listFilePath[1]" alt="" />
                                                </div>
                                                <div @click="openViewer(2,item.listFilePath)" class="item-img item-more-img" v-if="item.listFilePath.length > 2">
                                                    <common-image :filePath="item.listFilePath[2]" alt="" />
                                                    <span v-if="item.listFilePath.length > 3" class="bg"></span>
                                                    <span v-if="item.listFilePath.length > 3" class="nb-more">+{{ item.listFilePath?.length - 3 }}</span>
                                                </div>
                                                <div style="display: none;" class="item-img" v-if="item.listFilePath.length > 3">
                                                    <common-image :filePath="im" alt="" v-for="(im,imD) in item.listFilePath.slice(3)" :key="imD" />
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                    <div v-else-if="item.type == 2" class="p-3 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-end mb-3">
                                        <div @click="openFilePath(fi)" class="upload-file-mess" v-for="(fi,i) in item.listFilePath" :key="i">
                                            <span class="icon">
                                                <img src="/assets/img-fix/icon/document-solid-dark.svg" alt="">
                                            </span>
                                            <span class="text">{{thenFileName(fi)}}</span>
                                        </div>
                                    </div>
                                    <!--end::Text
                                    <!--end::Text-->
                                </div>
                                <!--end::Wrapper-->
                            </div>
                        </template>
                        <!--end::Message(in)-->

                    </div>
                    <!--end::Messages-->
                </div>
                <!--end::Card body-->
                <!--begin::Card footer-->
                <div class="card-footer pt-4" id="kt_chat_messenger_footer">
                    <!--begin::Input-->
                    <textarea @keydown="handleKeyDown" v-model="objMessage.content" class="form-control form-control-flush mb-3" rows="1" data-kt-element="input" placeholder="Nhập tin nhắn"></textarea>
                    <!--end::Input-->
                    <!--begin:Toolbar-->
                    <div class="d-flex flex-stack">
                        <!--begin::Actions-->
                        <div class="d-flex align-items-center me-2">
                            <button @click="addFile()" class="btn btn-sm btn-icon btn-active-light-primary me-1" type="button" data-bs-toggle="tooltip" title="Coming soon">
                                <i class="ki-duotone ki-paper-clip fs-3"></i>
                            </button>
                            <button @click="addImage()" class="btn btn-sm btn-icon btn-active-light-primary me-1" type="button" data-bs-toggle="tooltip" title="Coming soon">
                                <i class="ki-duotone ki-exit-up fs-3">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                            </button>
                        </div>
                        <!--end::Actions-->
                        <!--begin::Send-->
                        <button @click="sendMessage(1)" class="btn btn-primary" type="button" data-kt-element="send">Gửi tin</button>
                        <!--end::Send-->
                    </div>
                    <!--end::Toolbar-->
                </div>
                <!--end::Card footer-->
            </div>
            <!--end::Messenger-->


            <input multiple class="hidden-input" @change="handleFileSelect(3,$event)" ref="imageInput" type="file" accept="image/jpeg, image/png, image/gif, image/bmp, image/webp, image/tiff, image/svg+xml, image/vnd.microsoft.icon">
            <input multiple class="hidden-input" @change="handleFileSelect(2,$event)" ref="fileInput" type="file" accept=".pdf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf">

            <!--add user to group-->
            <CommonModal size="mw-950px" title="Thêm thành viên vào nhóm chat" v-if="openAddUser" @close="closeModalAddUser()">
                <template #body>

                    <div class="block-detail-yc-page">

                        <div class=" filter-file row row-cols-3">
                            <div class="col-4 col-xxl-4">
                                <div class="form-custom-medcat">
                                    <label class="form-label">Tên tài khoản</label>
                                    <input @keyup.enter="getListUser()" type="text" class="form-control" v-model="filterUser.keyword">
                                </div>
                            </div>
                            <div class="col-4 col-xxl-4">
                                <div class="form-custom-medcat">
                                    <label class="form-label">Loại tài khoản</label>
                                    <common-select-enum v-model="filterUser.type" placeholder="" code="UserTypeEnum" />
                                </div>
                            </div>

                            <div class="col-4 ">
                                <div class="btn-search-filter">
                                    <a href="javascript:;" class="btn-border" @click="getListUser()">
                                        <span class="text">Tìm kiếm</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="block-table-site">
                            <div class="wp-table-site">
                                <table class="ct-table-site table">
                                    <thead class="thead-table">
                                        <tr class="tr-thead">
                                            <td class="text-title-tb td-stt">STT</td>
                                            <td class="text-title-tb">
                                                Họ và tên
                                            </td>
                                            <td class="text-title-tb ">Email</td>
                                            <td class="text-title-tb ">Số điện thoại</td>
                                            <td class="text-title-tb ">Loại tài khoản</td>
                                            <td class="text-title-tb ">
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody class="tbody">
                                        <tr class="tr-table" v-for="(item, index) in listUser" :key="item.id">
                                            <td class="td-table-site td-stt">
                                                <div class="ct-padding-table">
                                                    <p class="text">{{(index + 1) + filterUser.pageIndex * filterUser.pageSize - filterUser.pageSize}}</p>
                                                </div>
                                            </td>
                                            <td class="td-table-site">
                                                <div class="status-table">
                                                    <common-avatar :src="item.avatar" :name="item.fullName" />
                                                    {{ item.fullName }}
                                                </div>
                                            </td>
                                            <td class="td-table-site">
                                                <div class="box-info-user-table">
                                                    <p class="name">  {{item.email}}</p>
                                                </div>
                                            </td>
                                            <td class="td-table-site">
                                                <div class="box-info-user-table">
                                                    <p class="name">  {{item.phoneNumber}}</p>
                                                </div>
                                            </td>
                                            <td class="td-table-site">
                                                <div class="box-info-user-table">
                                                    <common-enum-label :value="item.type" code="UserTypeEnum"></common-enum-label>
                                                    <!-- <span class="text-muted  d-block fs-7 mt-1" v-if="item.objectName">  {{item.objectName}}</span> -->
                                                </div>
                                            </td>
                                            <td class="td-table-site">
                                                <label class="form-check form-check-sm form-check-custom form-check-border ct-checked-site">
                                                    <input :disabled="isSelected(item.id)" class="form-check-input" type="checkbox" :value="item.id" v-model="objCreateChatGroup.userIds">
                                                </label>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex flex-stack flex-wrap" v-if="totalRowsUser">
                                <div class="fs-6 fw-semibold text-gray-700">
                                    Hiển thị {{formatNumber(filterUser.pageIndex * filterUser.pageSize- filterUser.pageSize +1)}} đến {{ formatNumber(totalRows> (filterUser.pageIndex * filterUser.pageSize) ? (filterUser.pageIndex * filterUser.pageSize) : totalRowsUser) }} trong số {{formatNumber(totalRowsUser)}} hồ sơ
                                </div>
                                <common-pagination :totalRecords="totalRowsUser" :currentPage="filterUser.pageIndex" :pageSize="filterUser.pageSize" @pageChange="pageChange"></common-pagination>
                            </div>
                        </div>
                    </div>

                </template>

                <template #footer>
                    <!--begin::Button-->
                    <button type="reset" @click="addUserToChatGroup()"
                            class="btn btn-light-primary me-3">
                        Tạo
                    </button>
                    <button type="reset" @click="closeModalAddUser()"
                            id="kt_modal_add_customer_cancel"
                            class="btn btn-light me-3">
                        Hủy
                    </button>
                    <!--end::Button-->
                    <!--begin::Button-->
                    <!-- <common-button-loading :func="openViewer(1.[])" title="Lưu"></common-button-loading> -->
                    <!--end::Button-->
                </template>
            </CommonModal>
        </div>
    </common-modal-slide>
</template>
<script lang="ts">
    import { useRoute, useRouter } from 'vue-router';
    import { api as viewerApi } from 'v-viewer'
    import 'viewerjs/dist/viewer.css';
    import { onMounted, onUpdated } from 'vue';
    import { defineComponent, ref } from "vue";
    import { SignalRService } from "~/core/services/signalRService";
    import { getUser } from "@/core/services/UserService";
    import type { ListChatMessageByGroupDto, ChatGroupDetailDto, CreateChatGroupDto, GetListUserForCreateChatGroupQuery, UserListDto } from "~/core/services/ApiClient";
    import { formatDate, formatDateTime, formatNumber } from "~/core/helpers/util";
    import FileService from "~/core/services/FileService";
    import { CommonModal } from '#build/components';
    import { MenuComponent } from 'assets/ts/components';
    const { showError, showInfo, showSuccess, showConfirm } = useMessageBox();
    const { upload } = useStorage();
    export default defineComponent({
        props: {
            currentChatGroupId: {
                type: Number,
                required: true,
                default: 0,
            },
        },
        setup(props, { emit }) {

            const show = ref(false);
            const apiClient = useApiClient();
            const totalRows = ref(0);
            const images = ref<string[]>([]);
            const totalRowsMessage = ref(0);
            const totalRowsUser = ref(0);
            const count = ref(0);
            const $loading = useLoading();
            const openCreate = ref(false);
            const openAddUser = ref(false);
            const detailChatGroup = ref<object>({});
            const currentUser = ref<object>({});
            currentUser.value = getUser();
            const listChatMessage = ref<ListChatMessageByGroupDto[]>([]);
            const objCreateChatGroup = ref(<CreateChatGroupDto>{
                name: "",
                type: 0,
                userIds: []
            });
            const filterUser = ref(<GetListUserForCreateChatGroupQuery>{
                sortExpression: "id desc",
                pageSize: 15,
                pageIndex: 1,
                keyword: "",
                status: 0,
                type: null,
                objectId: 0,
                roleIds: [],
                chatGroupType: 0
            });
            const listUser = ref<UserListDto[]>([]);
            const filter = ref(<object>{
                pageSize: 100,
                pageIndex: 1,
                keyword: ""
            });
            const filterListMessage = ref(<object>{
                pageSize: 20,
                skipSize: 0,
                chatGroupId: 0
            });
            const objMessage = ref(<object>{
                senderId: getUser().id,
                chatGroupId: 0,
                content: "",
                type: 1
            });
            const closeChatBox = () => {
                emit("closeChatBox");
            };
            const backListChat = () => {
                emit("backList");
            };
            const isSelected = (id: number) => {
                if (objCreateChatGroup.value.type === 1) {
                    return objCreateChatGroup.value.userIds.length > 0 && !objCreateChatGroup.value.userIds.includes(id);
                }
                else
                    return false;
            };
            const openViewer = (index, listPath) => {
                images.value = [];
                if (listPath.length > 0) {
                    for (var i = 0; i < listPath.length; i++) {
                        var path = new FileService().getFileFullPath(listPath[i] ?? "");
                        images.value.push(path);
                    }
                }
                const $viewer = viewerApi({
                    options: {
                        toolbar: true,
                        initialViewIndex: index
                    },
                    images: images.value
                })
            };
            const fileInput = ref<HTMLInputElement | null>(null);
            const imageInput = ref<HTMLInputElement | null>(null);
            const addFile = () => {
                fileInput.value?.click();
            };
            const addImage = () => {
                imageInput.value?.click();
            };
            const handleFileSelect = (type: number, event: Event) => {
                const listPath = ref<string[]>([]);
                console.log('type', type);
                const input = event.target as HTMLInputElement;

                if (input.files?.[0]) {
                    const uploadPromises: Promise<string | null>[] = [];

                    for (let i = 0; i < input.files.length; i++) {
                        const uploadPromise = upload(input.files[i])
                            .then((path) => {
                                if (path) {
                                    return path.toString();
                                } else {
                                    showError("Tải file không thành công");
                                    return null;
                                }
                            })
                            .catch((err) => {
                                showError("Tải file không thành công");
                                return null;
                            });

                        uploadPromises.push(uploadPromise);
                    }
                    Promise.all(uploadPromises).then((paths) => {
                        listPath.value = paths.filter((path) => path !== null) as string[];

                        if (listPath.value.length > 0) {
                            objMessage.value.content = JSON.stringify(listPath.value);
                            sendMessage(type);
                        }
                    });
                }
            };
            const getListMessageOfGroup = () => {

                filterListMessage.value.skipSize = listChatMessage.value.length;
                apiClient
                    .getListMessageByChatGroupId(filterListMessage.value.chatGroupId, filterListMessage.value.skipSize, filterListMessage.value.pageSize)
                    .then((response) => {
                        const chatBody = document.getElementById('kt_chat_messenger_body');
                        const previousScrollHeight = chatBody.scrollHeight;
                        if (response.data?.data && response.data?.data.length > 0) {
                            listChatMessage.value = [...response.data?.data, ...listChatMessage.value];
                        }
                        totalRowsMessage.value = response.data?.totalRows ?? 0;
                        count.value += 1;
                        if (count.value == 1) {
                            adjustChatBodyHeight();
                        }
                        else {
                            nextTick().then(() => {
                                 chatBody.scrollTop = chatBody.scrollHeight - previousScrollHeight;
                            });
                           
                            // window.addEventListener('resize', adjustChatBodyHeight);
                        }
                    })
                    .catch(() => {

                    });

            };
            const getDetailChatGroup = () => {
                apiClient
                    .getDetailChatGroup(filterListMessage.value.chatGroupId)
                    .then((response) => {
                        detailChatGroup.value = response.data;
                    })
                    .catch(() => {

                    });

            };

            const handleKeyDown = (event) => {
                if (event.key === "Enter") {
                    if (event.shiftKey) {
                        event.preventDefault();

                        const cursorPosition = event.target.selectionStart;
                        objMessage.value.content = objMessage.value.content + "\n";
                        nextTick(() => {
                            event.target.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
                        });
                    } else {
                        event.preventDefault();
                        sendMessage(1);
                    }
                }
            };
            const sendMessage = (type: number) => {

                if (objMessage.value.content) {

                    objMessage.value.chatGroupId = props.currentChatGroupId;
                    objMessage.value.type = type;
                    if (objMessage.value.chatGroupId > 0) {
                        SignalRService.sendMessage(objMessage.value)
                    }
                    objMessage.value.content = "";
                }
            };
            const scrollToBottom = async () => {
                await nextTick();
                const chatBody = document.getElementById('kt_chat_messenger_body');
                if (chatBody && count.value == 1) {

                    chatBody.scrollTop = chatBody.scrollHeight;
                }
            };

            onUpdated(() => {

            });

            const startChat = (chatGroupId: number) => {
                filterListMessage.value.chatGroupId = chatGroupId;
                filterListMessage.value.skipSize = 0;
                listChatMessage.value = [];
                totalRowsMessage.value = 0;
                count.value = 0;
                getDetailChatGroup();
                getListMessageOfGroup();

            };
            const thenFileName = (path: string) => {
                const lastSlashIndex = path.lastIndexOf('/');
                if (lastSlashIndex !== -1) {
                    return path.substring(lastSlashIndex + 1);
                }
                return path;
            };
            const openFilePath = (path: string) => {
                var fullPath = new FileService().getFileFullPath(path ?? "");
                window.open(fullPath, '_blank');
            };
            const adjustChatBodyHeight = () => {
                const chatBody = document.getElementById('kt_chat_messenger_body');
                if (chatBody) {
                    chatBody.addEventListener('scroll', handleScroll, { passive: true });
                    scrollToBottom();
                }
            };
            const handleScroll = () => {
                const chatBody = document.getElementById('kt_chat_messenger_body');

                if (chatBody) {
                    // Kiểm tra nếu đã cuộn đến đầu trang
                    if (chatBody.scrollTop === 0 && totalRowsMessage.value > listChatMessage.value.length) {

                        getListMessageOfGroup();
                    }
                }
            };
            onMounted(() => {

                new MenuComponent(document.getElementById("box-add-user"));
                SignalRService.onReceiveMessage((data: object) => {
                    console.log('nhận message', data);
                    if (data.chatGroupId == props.currentChatGroupId) {
                        if (data.senderId != currentUser.value.id)
                            readMessage();
                        listChatMessage.value.push(data);
                        totalRowsMessage.value += 1;
                        scrollToBottom();
                    }
                });
            });
            const closeModalAddUser = () => {
                objCreateChatGroup.value.userIds = [];
                openAddUser.value = false;
            };
            const getListUser = () => {
                $loading.show();
                apiClient
                    .getListUserForCreateChatGroup(filterUser.value as GetListUserForCreateChatGroupQuery)
                    .then((response) => {
                        listUser.value = response.data?.data ?? [];
                        totalRowsUser.value = response.data?.totalRows ?? 0;
                        $loading.hide();
                    })
                    .catch(() => {
                        $loading.hide();
                    });
            };
            const pageChange = (page: number) => {
                filterUser.value.pageIndex = page;
                getListUser();
            };
            const createdChatGroup = () => {
                $loading.show();
                apiClient
                    .createChatGroup(objCreateChatGroup.value)
                    .then((response) => {
                        $loading.hide();
                        closeModal();
                        if (response.data)
                            startChat(response.data.id);
                    })
                    .catch(() => {
                        $loading.hide();
                    });
            };
            const openUserToChatGroup = () => {
                getListUser();
                openAddUser.value = true;
            };
            const addUserToChatGroup = () => {
                $loading.show();
                apiClient
                    .addUserToChatGroup(props.currentChatGroupId, objCreateChatGroup.value.userIds)
                    .then((response) => {
                        $loading.hide();
                        showSuccess("Thêm thành công");
                        if (response) {
                            closeModalAddUser();
                            getDetailChatGroup();
                        }
                    })
                    .catch(() => {
                        $loading.hide();
                    });
            };
            const readMessage = () => {
                SignalRService.sendReadMessage(props.currentChatGroupId);
            };
            const router = useRouter();
            const gotoDocument = () => {
                if (detailChatGroup.value.documentId > 0) {
                    router.push(`/documents?documentId=${detailChatGroup.value.documentId}`);
                }
            };
            startChat(props.currentChatGroupId);
            return {
                createdChatGroup,
                totalRows,
                filter,
                formatDateTime,
                filterListMessage,
                startChat,
                openCreate,
                detailChatGroup,
                listChatMessage,
                currentUser,
                objMessage,
                sendMessage,
                fileInput,
                imageInput,
                addFile,
                handleFileSelect,
                addImage,
                thenFileName,
                openFilePath,
                adjustChatBodyHeight,
                scrollToBottom,
                count,
                openViewer,
                images,
                show,
                objCreateChatGroup,
                filterUser,
                listUser,
                getListUser,
                formatNumber,
                totalRowsUser,
                isSelected,
                pageChange,
                openUserToChatGroup,
                openAddUser,
                closeModalAddUser,
                addUserToChatGroup,
                closeChatBox,
                handleKeyDown,
                gotoDocument,
                backListChat
            };
        },
    });
</script>
<style>
    .ellipsis {
        max-width: 160px; /* Chiều rộng cụ thể mà bạn muốn */
        white-space: nowrap; /* Ngăn không cho văn bản xuống dòng */
        overflow: hidden; /* Ẩn phần văn bản vượt quá chiều rộng của thẻ div */
        text-overflow: ellipsis; /* Thêm dấu ba chấm (...) khi văn bản quá dài */
    }

    #kt_chat_messenger_body {
        overflow-y: auto;
    }
</style>